import { CREATE_CITA_REQUEST, CREATE_CITA_SUCCESS, CREATE_CITA_FAILURE } from '../Action-types';

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const citasReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CITA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case CREATE_CITA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };

    case CREATE_CITA_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default citasReducer;
